<template>
  <div>
    <div class="shadow_box rounded-lg p-6 relative flex flex-col">
      <p class="title"><strong>Pesquisa</strong></p>
      <form class="mt-1 w-full" @submit.prevent>
        <div class="flex flex-wrap mb-4 px-4">
          <multi-select-input v-model="filters.ShelfLifeRules.market_network" :multiple="true"
            :options="options.marketNetworkSearch" class="lg:pr-6 w-full lg:w-1/4 mt-3 lg:mt-0" label="Rede" />
          <multi-select-input v-model="filters.ShelfLifeRules.market" :multiple="true" :options="options.marketSearch"
            class="lg:pr-6 w-full lg:w-1/4 mt-3 lg:mt-0" label="Loja" />
          <multi-select-input v-model="filters.ShelfLifeRules.provider" :multiple="true" :options="options.providerSearch"
            class="lg:pr-6 w-full lg:w-1/4 mt-3 lg:mt-0" label="Fornecedor" />
          <multi-select-input v-model="filters.ShelfLifeRules.brand" :multiple="true" :options="options.brandSearch"
            class="lg:pr-6 w-full lg:w-1/4 mt-3 lg:mt-0" label="Marca" />
          <multi-select-input v-model="filters.ShelfLifeRules.products" :multiple="true" :options="options.productSearch"
            class="lg:pr-6 w-full lg:w-1/4 mt-3" label="Produtos" />
        </div>
        <div class="flex flex-shrink-0 flex-wrap items-center justify-start p-4 rounded-b-md gap-1">
          <button
            class="btn-purple px-6 py-2.5 text-white font-roboto font-medium text-xs uppercase rounded shadow-md border-solid border-2 border-transparent hover:bg-gray-700 hover:shadow-lg focus:bg-gray-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-gray-800 active:shadow-lg transition duration-150 ease-in-out "
            @click.submit.prevent="reloadData">
            <font-awesome-icon icon="fa-magnifying-glass" class="text-white text-sm mr-0 lg:mr-2" />
            Pesquisar
          </button>

          <button type="button"
            class="btn flex items-center text-purple-100 font-roboto font-medium px-6 py-2.5 text-xs uppercase border-solid border-2 border-purple-100"
            @click.submit.prevent="clearSearch">
            <font-awesome-icon icon="fa-eraser" class="text-purple text-sm mr-0 lg:mr-2" />
            Limpar
          </button>
        </div>
      </form>
    </div>

    <Head title="Regras" />
    <div class="shadow_box rounded-lg p-6 mt-4">
      <h1 class="mb-6 text-2xl text-gray-777 font-roboto uppercase">
        <span class="whitespace-nowrap overflow-hidden">Regras cadastradas</span>
      </h1>

      <data-table v-if="loadTable" v-model:columns="columns" :route="'shelf_life_rules/list'" :query="getQuery"
        no-data-label="Nenhuma regra cadastrada" no-result-label="Nenhuma regra encontrada">
        <template #table.cell.content.notifications="{ value, row }">
          <switch-input v-model="row.notifications" labelChecked="Ativo" labelUnchecked="Inativo"
            @click="changeNotifications(row)" />
        </template>
        <template #grid.content.body.notifications="{ value, row }">
          <switch-input v-model="row.notifications" labelChecked="Ativo" labelUnchecked="Inativo"
            @click="changeNotifications(row)" />
        </template>
        <template #table.cell.content.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 grid-rows-auto gap-4">
            <span @click="openModalEdit(row)" title="Editar"
              class="bg-purple-200 text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center action-buttons edit-button">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" /><span class="btn-label">Editar</span>
            </span>
            <span @click="openModalConfirmDelete(row)" title="Excluir"
              class="bg-red_delete text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center action-buttons delete-button">
              <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" /><span class="btn-label">Excluir</span>
            </span>
          </div>
        </template>
        <template #grid.content.body.actions="{ value, row }">
          <div class="inline-grid grid-cols-2 grid-rows-auto gap-4">
            <span @click="openModalEdit(row)" title="Editar"
              class="bg-purple-200 text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center action-buttons edit-button">
              <font-awesome-icon icon="fa-pencil" class="text-white pr-2" /><span class="btn-label">Editar</span>
            </span>
            <span @click="openModalConfirmDelete(row)" title="Excluir"
              class="bg-red_delete text-white cursor-pointer text-sm py-2 px-4 rounded inline-flex items-center action-buttons delete-button">
              <font-awesome-icon icon="fa-trash-can" class="text-white pr-2" /><span class="btn-label">Excluir</span>
            </span>
          </div>
        </template>

        <template #after.reload-button>
          <button class="flex items-end font-roboto font-medium btn-purple uppercase" @click.prevent="openModalEdit({})">
            <font-awesome-icon icon="fa-plus" class="text-white text-lg mr-0 lg:mr-2" />
            <span class="hidden lg:block">Adicionar Regra</span>
          </button>
        </template>
      </data-table>
    </div>
  </div>

  <modal-delete ref="modalDelete" @confirm="reloadTable"></modal-delete>

  <modal-edit id="modal-regra" ref="modalEdit" title="Regra" url="shelf_life_rules" @submitForm="reloadTable">
    <template #form="{ item }">
      <radiobox
        :required="true"
        v-model="item.type"
        @change="changeTypeOfRule(item)"
        :options="types_options"
        class="w-full"
        label="Tipo"
        :error="item.errors.type" />

      <multi-select-input
        required="true"
        v-if="['market_network', 'market', 'provider', 'brand', 'product'].includes(item.type)"
        @select="updateOptions(item)"
        appendTo="#modal-regra"
        v-model="item.market_networks"
        :error="item.errors.market_networks"
        :multiple="true"
        :options="options.marketNetwork"
        class="lg:pr-6 w-full lg:w-1/2 mt-6"
        label="Rede" />

      <multi-select-input
        required="true"
        v-if="['market', 'provider', 'brand', 'product'].includes(item.type)"
        @select="updateOptions(item)"
        appendTo="#modal-regra"
        v-model="item.markets"
        :error="item.errors.markets"
        :multiple="true"
        :options="options.market"
        class="w-full lg:w-1/2 mt-6"
        label="Loja" />

      <multi-select-input
        required="true"
        v-if="['provider', 'brand', 'product'].includes(item.type)"
        @select="updateOptions(item)"
        appendTo="#modal-regra"
        v-model="item.providers"
        :error="item.errors.providers"
        :multiple="true"
        :options="options.provider"
        class="lg:pr-6 w-full lg:w-1/2 mt-6"
        label="Fornecedor" />

      <multi-select-input
        required="true"
        v-if="['brand', 'product'].includes(item.type)"
        @select="updateOptions(item)"
        appendTo="#modal-regra"
        v-model="item.brands"
        :error="item.errors.brands"
        :multiple="true"
        :options="options.brand"
        class="w-full lg:w-1/2 mt-6"
        label="Marca" />

      <multi-select-input
        required="true"
        v-if="['product'].includes(item.type)"
        @select="updateOptions(item)"
        appendTo="#modal-regra"
        v-model="item.products"
        :error="item.errors.products"
        :multiple="true"
        :options="options.product"
        class="lg:pr-6 w-full lg:w-1/2 mt-6"
        label="Produto" />

      <div class="w-full"></div>
      <text-input required="true" v-model="item.name" :error="item.errors.name" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Nome" />

<!--      <mask-input mask="####" v-model="item.response_time" :error="item.errors.response_time" class="w-full lg:w-1/2 mt-6" label="Tempo de resposta (dias)" />-->
      <div class="w-full lg:w-1/2 mt-6">
        <label class="font-bold mb-2 block">Cobrança após (em dias)</label>

        <div v-if="!item.response_times || item.response_times.length === 0" class="text-sm text-gray-500 mb-2">
          Nenhum dia de cobrança definido.
        </div>

        <div v-for="(day, index) in item.response_times" :key="index" class="flex items-center gap-2 mb-2">
          <mask-input
            mask="####"
            v-model.number="item.response_times[index]"
          class="w-full"
          :error="item.errors[`response_times.${index}`]"
          :placeholder="`Dia ${index + 1}`"
          />

          <button type="button" class="text-red-500 font-bold" @click="item.response_times.splice(index, 1)">x</button>
        </div>

        <button type="button" class="btn-purple px-3 py-1 text-xs mt-2" @click="item.response_times.push('')">
          + Adicionar dia
        </button>
      </div>

      <date-input v-model="item.start_date" :error="item.errors.start_date" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Data de inicio" required="true" />

      <mask-input mask="####" required="true" v-model="item.recurrence" :error="item.errors.recurrence" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Recorrência da atividade (dias)" />
      <multi-select-input appendTo="#modal-regra" v-model="item.days_of_week" :options="week_options" :error="item.errors.days_of_week" class="w-full lg:w-1/2 mt-6 lg:pr-6" label="Dias da semana"/>
      <radiobox v-model="item.notifications" :options="yes_no_options" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Notificações" :required="true" :error="item.errors.notifications" />
      <radiobox v-model="item.inform_quantity" :disabled="item.inform_quantity_required" :options="yes_no_options" class="w-full lg:w-1/2 mt-6" label="Informar Quantidade" :error="item.errors.inform_quantity" />
      <radiobox v-model="item.inform_quantity_required" :disabled="item.inform_quantity" :options="yes_no_options" class="lg:pr-6 w-full lg:w-1/2 mt-6" label="Quantidade (Obrigatório após x dias)" :error="item.errors.inform_quantity_required" />
      <mask-input mask="####" v-if="item.inform_quantity_required" required="true" v-model="item.inform_quantity_required_days" :error="item.errors.inform_quantity_required_days" class="w-full lg:w-1/2 mt-6" label="Quantidade de dias obrigatório" />
    </template>
  </modal-edit>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import axios from 'axios'

import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import MaskInput from '@/Shared/MaskInput'
import DataTable from '@/Shared/DataTable'
import DateInput from '@/Shared/DateInput'
import TooltipInfo from '@/Shared/TooltipInfo'
import MultiSelectInput from '@/Shared/MultiSelectInput'
import SwitchInput from '@/Shared/SwitchInput'
import ModalEdit from '@/Shared/ModalEdit'
import ModalDelete from '@/Shared/ModalDelete'
import SelectInput from '@/Shared/SelectInput'
import Radiobox from '@/Shared/RadioInput.vue'

import { useMemorizeFilters } from '@/Mixins/MemorizeFilters'
import { getFiltersMixin } from '@/Mixins/GetFilters'

export default {
  components: {
    Head,
    LoadingButton,
    TextInput,
    DateInput,
    DataTable,
    TooltipInfo,
    MultiSelectInput,
    Link,
    SwitchInput,
    ModalEdit,
    ModalDelete,
    SelectInput,
    MaskInput,
    Radiobox,
  },

  props: {
    statustSearch: Array,
    salesPromoterSearch: Array,
    types_options: Object,
    week_options: Object,
    yes_no_options: Object,
  },

  layout: Layout,

  mixins: [
    getFiltersMixin,
  ],

  data() {
    return {
      loadTable: true,
      showFilters: false,

      options: {
        marketNetworkSearch: [],
        marketSearch: [],
        providerSearch: [],
        brandSearch: [],
        productSearch: [],


        marketNetwork: [],
        market: [],
        provider: [],
        brand: [],
        product: [],
      },

      columns: [
        {
          uniqid: 'name',
          label: 'Nome',
          field: 'name',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.name ?? ''
        },
        {
          uniqid: 'type',
          label: 'Tipo da Regra',
          field: 'type',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.type_label ?? ''
        },
        {
          uniqid: 'type',
          label: 'Recorrência',
          field: 'type',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.recurrence ? (row.recurrence + ' dia' + (row.recurrence > 1 ? 's' : '')) : ''
        },
        {
          uniqid: 'type',
          label: 'Quantidade',
          field: 'type',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'border-b text-sm',
          headerClass: 'p-4 text-left',
          format: (val, row) => row.inform_quantity ? 'Obrigatório' : ''
        },
        {
          uniqid: 'notifications',
          label: 'Notificações',
          field: 'notifications',
          visible: true,
          sortable: true,
          sortOrder: 'asc',
          classes: 'border-b text-sm',
          headerClass: 'p-4 text-left',
        },
        {
          uniqid: 'actions',
          label: 'Ações',
          field: 'id',
          visible: true,
          align: 'center',
          classes: 'py-3 border-b',
          headerClass: 'p-4',
        },
      ],
    }
  },

  computed: {
    getQuery() {
      return Object.entries(this.getFilters()).map(([key, val]) => `search2[${key}]=${val}`).join('&')
    },
  },

  watch: {
    'filters.ShelfLifeRules': {
      handler() {
        this.getFiltersFromAPI()
      },
      deep: true,
    },
  },

  created () {
    this.getOptions();
  },

  methods: {
    openModalConfirmDelete(item) {
      this.$refs.modalDelete.openModalDelete(item, `/shelf_life_rules/${item.id}`, `Deseja realmente excluir a regra ${item.name}?`);
    },
    openModalEdit(i) {
      let start_date = null

      if (i.start_date) {
        // const [year, month, day] = i.start_date.split('-')
        // start_date = new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('pt-br')
        start_date = i.start_date
      }


      let item = {
        start_date,

        id: i.id,
        shelf_life_rules_rels_id: i.shelf_life_rules_rels_id ?? null,
        type: i.type ?? null,
        name: i.name,
        // response_time: i.response_time,
        response_times: i.response_times ?? [], // ✅ novo campo
        notifications: i.notifications ?? null,
        recurrence: i.recurrence,
        inform_quantity: i.inform_quantity ?? null,
        inform_quantity_required: i.inform_quantity_required ?? null,
        inform_quantity_required_days: i.inform_quantity_required_days,
        days_of_week: i.days_of_week,
        market_networks: i.market_networks ?? [],
        markets: i.markets ?? [],
        providers: i.providers ?? [],
        brands: i.brands ?? [],
        products: i.products ?? [],
      }
      this.$refs.modalEdit.openModalEdit(item);
      this.getOptions();
    },
    changeNotifications(item) {
      item.notifications = !item.notifications;
      this.$inertia.post("/shelf_life_rules/update-notification", item);
    },
    reloadData() {
      this.getFiltersFromAPI()
      this.reloadTable()
    },
    reloadTable() {
      this.loadTable = false;
      setTimeout(() => this.loadTable = true, 10);
    },
    clearSearch() {
      this.clearFilters()
      this.getFiltersFromAPI()
      this.reloadTable();
    },
    updateOptions(item) {
      let params = {
        market_network: item.market_networks,
        market: item.markets,
        provider: item.providers,
        brand: item.brands,
        products: item.products,
      };

      this.getOptions(params);
    },


    changeTypeOfRule(item) {

      const clearFilters = {
        market_network: ['markets','providers','brands','products'],
        market: ['providers','brands','products'],
        provider: ['brands','products'],
        brand: ['products'],
      }


      if (clearFilters[item.type]) {
        for(let field of clearFilters[item.type])
          item[field] = []
      }
    },

    async getOptions(params = {}) {
        const response = await axios.get('/get-filters', {
            params,
        });

        this.options.marketNetwork = response.data.marketNetworkSearch;
        this.options.market = response.data.marketSearch;
        this.options.provider = response.data.providerSearch;
        this.options.brand = response.data.brandSearch;
        this.options.product = response.data.productSearch;
    }
  },

  setup() {
    const { filtersStore, setFiltersComponent, getFiltersComponent, clearFiltersComponent } = useMemorizeFilters()

    setFiltersComponent('ShelfLifeRules')

    const clearFilters = () => clearFiltersComponent('ShelfLifeRules')
    const getFilters = () => getFiltersComponent('ShelfLifeRules')

    return {
      getFilters,
      clearFilters,
      filters: filtersStore.filters
    }
  },
}
</script>
